<template>
  <div class="row">
    <img class="login-element" src="/static/img/background/login_element.png" alt="chancellery">
    <div class="col-lg-4 col-md-6 ml-auto mr-auto">
      <card type="login">
        <template #header>
          <h3 class="header text-center">
            Вход
          </h3>
        </template>
        <p-button
          v-if="useSso"
          class="mb-5"
          native-type="submit"
          type="info"
          round
          block
          @click="loginSso">
          <el-icon v-if="loading" class="is-loading">
            <Loading/>
          </el-icon>
          <span v-else>Через SSO</span>
        </p-button>
        <form v-else @submit.prevent="login">
          <fg-input
            v-model="form.phone"
            :disabled="loading"
            addon-left-icon="nc-icon nc-mobile"
            placeholder="Номер телефона"
            transform-method="onlyDigits"
            type="text"/>
          <fg-input
            v-model="form.password"
            :disabled="loading"
            addon-left-icon="nc-icon nc-key-25"
            placeholder="Пароль"
            type="password"
            transform-method="trim"
            watchable/>
          <p-button
            class="mt-5"
            :disabled="disableSubmitBtn"
            native-type="submit"
            type="info"
            round
            block>
            <el-icon v-if="loading" class="is-loading">
              <Loading/>
            </el-icon>
            <span v-else>Войти</span>
          </p-button>
        </form>
        <template #footer>
          <el-button
            type="info"
            link
            size="small"
            @click="handleLoginMethodClick">
            {{ changeLoginMethodBtnText }}
          </el-button>
        </template>
      </card>
    </div>
  </div>
</template>
<script>
import { Button, Card, Checkbox } from '@/components/UIComponents'
import { ElButton } from 'element-plus'
import { mapActions } from 'vuex'

export default {
  name: 'Login',
  components: {
    Card,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    ElButton,
  },
  data() {
    return {
      form: {
        phone: '',
        password: ''
      },
      loading: false,
      useSso: true,
    }
  },
  computed: {
    disableSubmitBtn() {
      return this.loading || !this.form.phone.trim() || !this.form.password.trim()
    },
    changeLoginMethodBtnText() {
      return this.useSso
        ? 'Войти по номеру телефона'
        : 'Войти через SSO'
    },
  },
  methods: {
    ...mapActions(['loginSso']),
    handleLoginMethodClick() {
      this.useSso = !this.useSso
    },
    toggleNavbar() {
      document.body.classList.toggle('nav-open')
    },
    closeMenu() {
      document.body.classList.remove('nav-open')
      document.body.classList.remove('off-canvas-sidebar')
    },
    async login() {
      this.loading = true
      try {
        await this.$store.dispatch('login', this.form)
        const user = this.$store.getters.user
        const role = user.roles[0].name
        const path = this.$sidebar.getStartPage(role)
        await this.$router.push(path)
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    }
  },
  beforeUnmount() {
    this.closeMenu()
  }
}
</script>
<style>
</style>
